// extracted by mini-css-extract-plugin
export default {"button":"CompletePeriodReportButton_button__gXFR9","spinner":"CompletePeriodReportButton_spinner__+eBCG"};